import { render, staticRenderFns } from "./prestorage.vue?vue&type=template&id=8c97218a&"
import script from "./prestorage.vue?vue&type=script&lang=js&"
export * from "./prestorage.vue?vue&type=script&lang=js&"
import style0 from "./prestorage.vue?vue&type=style&index=0&id=8c97218a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports